module.exports = require("react-dropzone");